import { useMemo } from "react";
import { get } from "lodash";
import { RaceInfoMyBets, RaceInfoMyBetsResults } from "@tvg/ts-types/Race";

type Props = {
  allRacesFromTrack: RaceInfoMyBets[];
};

function useResults(props: Props): Array<RaceInfoMyBetsResults> {
  const { allRacesFromTrack } = props;

  return useMemo(
    () =>
      allRacesFromTrack
        ? allRacesFromTrack.map((race) =>
            get(race, "results", [] as RaceInfoMyBetsResults)
          )
        : [],
    [allRacesFromTrack]
  );
}

export default useResults;
